export const DEFAULT_LOCATION = {
  latitude: 37.5001,
  longitude: 127.0385,
};
